module.exports = __webpack_public_path__ + "static/media/product-bg-1.38381b14.svg";